import './style.scss';
import React, { Suspense } from 'react';
import BorderedText from '../../bordered-text';

import yellowHeadIcon from '../../../resources/images/dashboard/yellow-head-icon.svg';
import stars from '../../../resources/images/dashboard/stars.svg';

const UserSaying = ({ language = 'en' }) => {
  return (
    <Suspense fallback={<div>{language === 'de' ? 'Laden...' : 'Loading...'}</div>}>
      <div className="user">
        <div className="user__container">
          {language === 'en' &&
            <h2 className="h2">
              What our
              <BorderedText
                text="users"
                backgroundColor="#D4FFDB"
                textColor="#39DA52"
                rotate="-4"
            />
              are saying
            </h2>
          }
          {language === 'de' &&
            <h2 className="h2">
              Was unsere
              <BorderedText
                text="User"
                backgroundColor="#D4FFDB"
                textColor="#39DA52"
                rotate="-4"
              />
              sagen
            </h2>
          }
          <div className="content">
            <div className="first-element">
              <div className="header-style">
                <img
                  className="circle"
                  src={yellowHeadIcon}
                  alt="Yellow head icon"
                />
                <p>Shamanix08</p>
                <div className="stars-style">
                  <img src={stars} alt="stars" loading="lazy" />
                </div>
              </div>
              {language === 'en' &&
                <h3>Measure heart rate during sessions</h3>
              }
              {language === 'de' &&
                <h3>Puls messen während der Sessions</h3>
              }
              {language === 'en' &&
                <p>
                  I had no idea I need such an app! Love the integration with Apple
                  Watch - I get notifications and I see that it tracks more health
                data when I use the app (those breathing exercises are
                AWESOME!!!).
                </p>
              }
              {language === 'de' &&
                <p>
                  Ich hatte keine Ahnung, dass ich so eine App brauche! Ich liebe die Integration mit der Apple Watch – ich bekomme Benachrichtigungen und sehe, dass mehr Gesundheitsdaten erfasst werden, wenn ich die App benutze (die Atemübungen sind der Wahnsinn!!!).
                </p>
              }
            </div>

            <div className="first-element">
              <div className="header-style">
                <img
                  className="circle"
                  src={yellowHeadIcon}
                  alt="Yellow head icon"
                />
                <p>rla1978</p>
                <div className="stars-style">
                  <img src={stars} alt="stars" loading="lazy" />
                </div>
              </div>
              {language === 'en' &&
                <h3>Very effective that puts privacy first</h3>
              }
              {language === 'de' &&
                <h3>Sehr wirksam und stellt Privatsphäre an erste Stelle</h3>
              }
              {language === 'en' &&
                <p>
                  Das ist eine der wenigen Apps, die wirklich deine Privatsphäre respektiert. Ich musste kein Konto anlegen, mich nirgendwo registrieren. Stress und Angst sind so persönliche Themen – genau das hat mich bisher von anderen Apps abgehalten. Earkick löst das richtig gut. Die App erinnert mich, Dinge einzutragen, ohne aufdringlich zu sein, und die Übungen sind kurz genug, um genau im richtigen Moment zu helfen. Ich nutze sie jetzt regelmäßig – und genau das ist der Schlüssel im Umgang mit Stress.
                </p>
              }
              {language === 'de' &&
                <p>
                  Dies ist eine der seltenen Apps, die Ihre Privatsphäre wirklich in den Vordergrund stellt. Ich musste weder ein Login noch ein Konto erstellen. Stress und Angstzustände sind so persönliche und private Probleme, dass ich bisher keine anderen Apps genutzt habe. Earkick hat das wirklich gut gemeistert. Insgesamt bin ich bisher von der App beeindruckt. Sie erinnert mich daran, Dinge zu protokollieren, ohne zu aufdringlich zu sein, und die Übungen sind schnell genug, um mich zu beruhigen. Sie hat mich dazu gebracht, regelmäßig Dinge zu tun, was der Schlüssel zur Stressbewältigung ist.
                </p>
              }
            </div>

            <div className="first-element margin-style">
              <div className="header-style">
                <img
                  className="circle"
                  src={yellowHeadIcon}
                  alt="Yellow head icon"
                />
                <p>frogslide</p>
                <div className="stars-style">
                  <img src={stars} alt="stars" loading="lazy" />
                </div>
              </div>
              {language === 'en' &&
                <h3>Great app for anxiety</h3>
              }
              {language === 'de' &&
                <h3>GTolle App bei Angstzuständen</h3>
              }
              {language === 'en' &&
                <p>
                  As a therapist that works with anxiety daily I cannot recommend
                  this app enough. Plus, they have wonderful customer service and
                  are constantly improving this app.
                </p>
              }
              {language === 'de' &&
                <p>
                  Als Therapeutin, die täglich mit Angst arbeitet, kann ich diese App nur empfehlen. Der Kundenservice ist großartig und das Team verbessert die App laufend.
                </p>
              }
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default UserSaying;
